import Vue from "vue";
import Router from "vue-router";
import AdminHome from "./AdminApp";
Vue.use(Router);

const adminChildRoutes = [
  {
    path: "dashboard",
    name: "admin-home",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/adminHome.vue")
  },
  {
    path: "courses",
    name: "CoursesListing",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/CoursesListing")
  },
  {
    path: "edit-profile",
    name: "edit-profile",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/EditProfile")
  },
  {
    path: "add-course",
    name: "AddCourse",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () => import(/* webpackChunkName: "about" */ "./views/AddCourse")
  },
  {
    path: "add-video",
    name: "AddVideo",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () => import(/* webpackChunkName: "about" */ "./views/AddVideo")
  },
  {
    path: "following-students",
    name: "following-students",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/FollowingStudents")
  },
  {
    path: "live-schedule",
    name: "live-schedule",
    meta: {
      requiredAuth: true,
      layout: "admin"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/LiveSchedule")
  }
];

const routes = [
  {
    path: "/admin",
    name: "Admin",
    component: AdminHome,
    children: adminChildRoutes,
    redirect: { name: "admin-home" },
    meta: {
      requiredAuth: true,
      layout: "admin"
    }
  },
  {
    path: "/admin/live_start",
    name: "liveStart",
    component: () =>
      import(/* webpackChunkName: "liveStart" */ "./views/LiveStart.vue"),
    meta: {
      layout: "admin",
      title: "Start Live Now",
      requiredAuth: true
    }
  }
];
export default routes;
